import { ENDPOINT } from 'api/endPoints/getRunRateAnalysis';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';

export const productivityRate: IHashmapItemComponentProps = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'dateRangeFilter', name: 'dateRangeFilter', defaultValue: 'R_4W' },
        { key: 'productivityPreDefined', name: 'productivityPreDefined', defaultValue: null },
        { key: 'activityType', name: 'activityType', defaultValue: 'ALL' },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'wbs', name: 'wbs', defaultValue: null },
    ],
    componentKey: 'productivityRate',
    title: 'Run Rate | Chart',
    id: 'productivityRate',
    reportStyle: {
        widgetSizesAvailable: {
            medium: MEDIUM,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: MEDIUM,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: true,
        },
        hideNarrativeEditor: true,
    },
    endpoint: ENDPOINT,
};
